import { Account } from '@/domain/usecases'
import { CompanyDetail } from '@/domain/usecases/company/company-detail'
import { CompanyDetailLoadDataType } from '@/presentation/pages/internal-company-manager/company/company-detail-page'
import { QueryClient } from 'react-query'
import { LoaderFunctionArgs, defer } from 'react-router-dom'
import InternalCompanyManagerBaseLoader from './internal-company-manager-base-loader'

export default class CompanyDetailLoader extends InternalCompanyManagerBaseLoader {
  private static readonly ID_PATH_PARAM_NAME = 'id'

  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient
  ) {
    super(account, queryClient)
  }

  async loader({ params }: LoaderFunctionArgs) {
    const id = params[CompanyDetailLoader.ID_PATH_PARAM_NAME] ?? ''

    return defer({
      data: super.importRemoteModule('makeRemoteCompanyDetail').then(async makeRemote => {
        const remoteCompanyDetail = makeRemote(this.queryClient) as CompanyDetail
        return {
          company: await remoteCompanyDetail.get(id)
        } as CompanyDetailLoadDataType
      })
    })
  }
}
